(() => {
if (customElements.get('cart-drawer')) return;
class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
    this.minuteurEnCours = false;
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink)
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });

    const cartLink2 = document.querySelector('#cart-icon-bubble2');
    if (!cartLink2) return;
      cartLink2.setAttribute('role', 'button');
    cartLink2.setAttribute('aria-haspopup', 'dialog');
    cartLink2.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink2)
    });
    cartLink2.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink2);
      }
    });
  }


  open(triggeredBy) {
 if(this.querySelector('#timer')){
    if (!this.minuteurEnCours) {
        this.demarrerMinuteur();
    }
 }
   
   // document.getElementsByClassName("closemenu")[0].click()
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
      this.refreshFocus();
    });

    // Barre de recompenses (maquette 4b) : rejoue le remplissage a l'ouverture et
    // apres renderContents (ajout au panier), qui recree le markup du drawer.
    if (window.cartRewards) window.cartRewards.sync();

    document.body.classList.add('overflow-hidden');
    window.eveCartImages.warm(this);
  }
   demarrerMinuteur() {
    this.minuteurEnCours = true;
    var tempsRestant = 60 * 8; // Durée du minuteur en secondes (exemple : 5 minutes)
    var intervalle = setInterval(() => {
        var minutes = parseInt(tempsRestant / 60, 10);
        var secondes = parseInt(tempsRestant % 60, 10);

        secondes = secondes < 10 ? "0" + secondes : secondes;

 $("#timer").text(minutes + ":" + secondes)
        if (--tempsRestant < 0) {
          $("#reservationCart").hide()
            clearInterval(intervalle);
            this.minuteurEnCours = false;
          
            // Actions à effectuer lorsque le minuteur est terminé
        }
    }, 1000);
}

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  refreshFocus() {
    if (!this.classList.contains('active')) return;
    const container = this.querySelector('.drawer__inner');
    if (container) trapFocus(container, container.querySelector('.drawer__close') || container);
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if(cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') && this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      var sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      window.eveCartImages.replace(sectionElement,
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector));
    }));
    this.classList.toggle('is-empty', !!this.querySelector('.drawer__inner-empty'));

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer'
      },
        {
      
      id: 'cart-icon-bubble',
      
     
    
      }
   
   

   
 
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends window.CartItems {
  getSectionsToRender() {
    if (document.getElementById('main-cart-items')) return super.getSectionsToRender();
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'cart-icon-bubble2',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

})();
